import React from 'react';
import { ReactComponent as DefaultOffImage } from '../../assets/icons/checkbox-off.svg';
import { ReactComponent as DefaultOnImage } from '../../assets/icons/checkbox-on.svg';

const Checkbox = ({onChange, checked, on, off}) => {

  let OnImage = on || DefaultOnImage;
  let OffImage = off || DefaultOffImage;

  const handleOnChange = () => {
    onChange({target: {checked: !checked}});
  }

  return (
    checked ?
      <OnImage className="icon base"
               style={{fill: 'var(--text-contrast-mid)',
                      }}
               onClick={handleOnChange} />
    :
    <OffImage className="icon base"
              style={{fill: 'var(--text-contrast-mid)',
                     }}
              onClick={handleOnChange} />
  );
};

export default Checkbox;
